import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { selectHighlight, selectLoading } from '../store/slice'
import { formatVal } from './../../../helpers/value'
import classes from './index.module.scss'

const DATA_KEYS = [
  { name: 'alerts.TOTAL_ALERTS', value: 'totalAlert' },
  { name: 'alerts.UNREAD_ALERTS', value: 'totalAlertUnread' },
  { name: 'alerts.TOTAL_NEGATIVE_ALERTS', value: 'totalAlertNegative' },
  { name: 'alerts.UNREAD_NEGATIVE_ALERTS', value: 'totalAlertNegativeUnread' },
]

export const Highlight = () => {
  const locale = useSelector((state) => state.i18n.locale)
  const highlight = useSelector(selectHighlight)
  const isLoading = useSelector(selectLoading('highlight'))

  return (
    <Element
      className={classes.highlight}
      style={{ opacity: isLoading ? 0 : 1 }}
    >
      {DATA_KEYS.map((item, index) => (
        <Element
          key={index}
          className={classes.highlightItem}
          style={{ backgroundColor: '#EFF3FA', color: '#3A414B' }}
        >
          <Element>
            <Translate value={item.name} />
          </Element>
          <Element style={{ fontSize: 16 }}>
            {formatVal(highlight[item.value], locale, false, 0)}
          </Element>
        </Element>
      ))}
    </Element>
  )
}
